// extracted by mini-css-extract-plugin
export var closeButton = "_2g-3";
export var header = "_2g-0";
export var link = "_2g-1";
export var retryButton = "_2g-2";